import { useEffect, useState } from "react";
import {
	getPrintGrantRemainingMs,
	grantPrintAccess,
	isSupportAccount,
} from "../../lib/utils/support-print-grant";
import { useCentralStore } from "../../store/Central";

export const SupportPrintGrantButton: React.FC = () => {
	const email = useCentralStore((state) => state.profile?.email);
	const [remainingMs, setRemainingMs] = useState(getPrintGrantRemainingMs());

	useEffect(() => {
		if (remainingMs <= 0) return;
		const interval = setInterval(() => {
			setRemainingMs(getPrintGrantRemainingMs());
		}, 1000);
		return () => clearInterval(interval);
	}, [remainingMs]);

	if (!isSupportAccount(email)) return null;

	const handleGrant = () => {
		grantPrintAccess();
		setRemainingMs(getPrintGrantRemainingMs());
	};

	const isActive = remainingMs > 0;
	const seconds = Math.ceil(remainingMs / 1000);

	return (
		<button
			onClick={handleGrant}
			aria-label="Drucker für 60 Sekunden freigeben"
			data-testid="support-print-grant-button"
			className={
				isActive
					? "bg-green-200 px-1 rounded"
					: "bg-yellow-200 px-1 rounded"
			}
		>
			{isActive ? `🖨 ${seconds}s` : "🖨 Drucker freigeben (1 Min.)"}
		</button>
	);
};
